import Link from 'next/link'
import type { ReactNode } from 'react'

/**
 * A dated, visible correction on the page that was corrected.
 *
 * The corrections policy (/methodology#corrections) says substantive errors
 * are published with a date and a description of what was wrong, and never
 * quietly edited. This is the on-page half of that; the methodology page keeps
 * the permanent list. Same styling as the bottled water database's note.
 */
export default function CorrectionNote({ date, children }: { date: string; children: ReactNode }) {
  return (
    <aside className="not-prose my-6 rounded-2xl border border-amber-300/60 bg-amber-50/70 p-5">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-forest mb-2">
        Correction · {date}
      </p>
      <p className="text-sm text-gray-700 leading-relaxed">
        {children}{' '}
        <Link href="/methodology#corrections" className="text-forest underline font-medium">
          Corrections policy
        </Link>
      </p>
    </aside>
  )
}
